import { ComponentMapperService } from './../../helpers/componentMapper.service';
import { Directive, Input, ViewContainerRef, ComponentFactoryResolver, Type } from '@angular/core';
import { COMPONENT_MAPPER } from '../../modules/shared.module';

@Directive({
  selector: '[appDynamicLoader]'
})

export class DynamicLoaderDirective {

  // In input verrà passato il selettore del componente da ricreare
  @Input() set data(data: DynamicLoaderDirectiveData) {
    this.load(data.componentSelectorName, data.inputParams, data.idLookupEntity);
  }

  constructor(private resolver: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef) { }

  load(componentSelector: string, inputParams: any = null, idLookupEntity: number = null): any {

    if (!componentSelector) {
      throw new Error('Failed to load dynamic component');
    }

    let componentInstance = this.getComponent(componentSelector);

    const componentFactory = this.resolver.resolveComponentFactory(componentInstance);

    const viewContainerRef = this.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<any>(
      componentFactory
    );

    //Controllo che nel componente che si vuole renderizzare sia presente DisableRedirectAfterSave così da poter gestire il redirect dopo aver salvato
    if (componentRef.instance["DisableRedirectAfterSave"] == null)
      throw new Error("Attenzione, la proprietà DisableRedirectAfterSave nel componente di aggiunta non è stata creata");
    else
      componentRef.instance["DisableRedirectAfterSave"] = true;

    if (inputParams != null) {
      let inputProps = Object.keys(inputParams);
      inputProps.forEach(p => {
        componentRef.instance[p] = inputParams[p];
      })
    }

    if (idLookupEntity != null)
      componentRef.instance["idLookupEntity"] = idLookupEntity;

  }

  /**
 * Restrituisce un componente passandogli come parametro la chiave
 * @param key
 */
  getComponent(key: any) {
    let component = key;
    if (typeof key == "string") {
      component = COMPONENT_MAPPER.get(key);
    }
    return component;
  }
}

export class DynamicLoaderDirectiveData {
  componentSelectorName: string;
  inputParams?: any;
  idLookupEntity?: number;
  isEditable?: boolean = false;
}
